import React from "react";

// Excel + PDF download buttons shared across the MIS report tabs.
// The parent supplies onExcel / onPdf handlers that build and save the file.
const base = {
  display: "inline-flex", alignItems: "center", gap: 6, border: "none",
  borderRadius: 9, padding: "8px 14px", fontSize: 13, fontWeight: 600,
  color: "#fff", cursor: "pointer",
};

export default function ExportButtons({ onExcel, onPdf, disabled, style }) {
  return (
    <div style={{ display: "inline-flex", gap: 8, ...style }}>
      <button
        type="button"
        onClick={onExcel}
        disabled={disabled}
        title="Download as Excel"
        style={{ ...base, background: "linear-gradient(135deg,#6366f1,#4f46e5)", opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <i className="fal fa-file-excel" /> Excel
      </button>
      <button
        type="button"
        onClick={onPdf}
        disabled={disabled}
        title="Download as PDF"
        style={{ ...base, background: "linear-gradient(135deg,#7c3aed,#6d28d9)", opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <i className="fal fa-file-pdf" /> PDF
      </button>
    </div>
  );
}
